import React from 'react';
import { Switch } from 'react-router-dom';
import classNames from 'classnames';

import { FeatureFlag } from 'app/api/services/site-configs/types';
import type { ExtendedRouteProps } from 'app/lib/routing/types';

import { ModulesScrollbar } from 'app/design-system/components/Scrollbar';
import { useFeatureFlag } from 'app/lib/feature-flags';
import { RouteWithSubRoutes } from 'app/lib/routing';
import { useSSR } from 'app/packages/components/SkipSSR';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import { LeftMenu } from '../LeftMenu';
import Header from './Header';
import Sidebar from './Sidebar';

import styles from './LayoutWithSidebars.module.scss';

interface LayoutWithSidebarsProps {
  routes?: ExtendedRouteProps[];
}

const LayoutWithSideBars: React.FC<LayoutWithSidebarsProps> = (props) => {
  const { routes } = props;
  const isLeftMenuNew = useFeatureFlag(FeatureFlag.LEFT_MENU);
  const isSSR = useSSR();
  const scrollbarClassName = classNames(styles.scrollbar, {
    [styles.scrollbarSSR]: isSSR,
  });

  const layoutContainerClassName = classNames(styles.layoutContainer, {
    [styles.layoutContainerSSR]: isSSR,
  });

  const leftMenuClassNames = classNames(
    styles.leftMenu,
    {
      [styles.leftMenuNew]: isLeftMenuNew,
    },
  );

  return (
    <>
      <Header />

      <div className={layoutContainerClassName}>
        <ErrorBoundary>
          <div className={leftMenuClassNames}>
            <LeftMenu />
          </div>
        </ErrorBoundary>

        <ErrorBoundary>
          <Sidebar />
        </ErrorBoundary>
      </div>

      <ErrorBoundary>
        <ModulesScrollbar isScrollReset
                          className={scrollbarClassName}>
          <Switch>
            {routes && routes.map((route, i) => (
              <RouteWithSubRoutes
                key={i}
                {...props}
                {...route} />
            ))}
          </Switch>
        </ModulesScrollbar>
      </ErrorBoundary>
    </>
  );
};

export default LayoutWithSideBars;
